import { useEffect, useState, useContext } from 'react';
import { HotelContext } from '../context/hotel'
import { fetch, fetchAll } from '../services/api';
import { usePersistentState } from './usePersistentState';
import { useLocalStorage } from "@penseapp/uselocalstorage";
import useApi from "./useApi";

export const useHourDisabled = (entity) => {
    const { sectionsByCode } = useContext(HotelContext)

    const [validateHourDisabled, setValidateHourDisabled] = useState("");
    const [hourConfig, setHourConfig] = useState(null);

    const daysOfWeek = {
        0: 'sunday',
        1: 'monday',
        2: 'tuesday',
        3: 'wednesday',
        4: 'thursday',
        5: 'friday',
        6: 'saturday'
    };

    useEffect(() => {
        if (sectionsByCode[entity]?.extras?.scheduleConfig) {
            setHourConfig(sectionsByCode[entity].extras.scheduleConfig);
        }
    }, [entity, sectionsByCode]);

    useEffect(() => {
        // Función para evaluar la configuración de horarios
        const evaluateHourConfig = () => {
            if (hourConfig) {
                let isDisabled = "";
                if (hourConfig.mode == "daily_availability") {
                    const now = new Date();
                    const currentHour = now.getHours()
                    const currentMinute = now.getMinutes();
                    const currentDay = now.getDay();
                    const currentDayName = daysOfWeek[currentDay];

                    // Primero verificar si el día está deshabilitado
                    if (hourConfig.notAvailableDays && hourConfig.notAvailableDays[currentDay]) {
                        isDisabled = "no-hours.disabled.day";
                    } else {
                        // Verificar si está dentro del rango de horas general
                        const currentTimeMinutes = currentHour * 60 + currentMinute;

                        // Parsear startHour y endHour que vienen en formato "HH:MM"
                        const [startHourStr, startMinuteStr] = hourConfig.startHour.split(':');
                        const [endHourStr, endMinuteStr] = hourConfig.endHour.split(':');

                        const startHour = parseInt(startHourStr);
                        const startMinute = parseInt(startMinuteStr);
                        const endHour = parseInt(endHourStr);
                        const endMinute = parseInt(endMinuteStr);
                        const duration = hourConfig.duration || 60;

                        const startTimeMinutes = startHour * 60 + startMinute;
                        const endTimeMinutes = endHour * 60 + endMinute;

                        if (currentTimeMinutes >= startTimeMinutes && currentTimeMinutes <= endTimeMinutes) {
                            // Verificar slots deshabilitados específicos
                            if (hourConfig.unavailableSlots && hourConfig.unavailableSlots[currentDayName]) {
                                const currentTimeString = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}`;
                                const unavailableSlots = hourConfig.unavailableSlots[currentDayName];

                                // Verificar si la hora actual está dentro de algún slot deshabilitado
                                const isInDisabledSlot = unavailableSlots.some(slot => {
                                    const [slotHourStr, slotMinuteStr] = slot.split(':');
                                    const slotHour = parseInt(slotHourStr);
                                    const slotMinute = parseInt(slotMinuteStr);

                                    const slotStartTimeMinutes = slotHour * 60 + slotMinute;
                                    const slotEndTimeMinutes = slotStartTimeMinutes + duration;
                                    const currentTimeMinutes = currentHour * 60 + currentMinute;

                                    const isInSlot = currentTimeMinutes >= slotStartTimeMinutes && currentTimeMinutes < slotEndTimeMinutes;
                                    
                                    return isInSlot;
                                });

                                if (isInDisabledSlot) {
                                    isDisabled = "no-hours.disabled.slot";
                                } else {
                                    isDisabled = "";
                                }
                            } else {
                                isDisabled = "";
                            }
                        } else {
                            isDisabled = "no-hours.disabled.general";
                        }
                    }
                } else {
                    isDisabled = "";
                }

                setValidateHourDisabled(isDisabled);
            }
        };

        // Evaluar inmediatamente
        evaluateHourConfig();

        // Configurar el intervalo para evaluar cada minuto
        const interval = setInterval(evaluateHourConfig, 60000);

        // Limpiar el intervalo cuando el componente se desmonte o cambie la entidad
        return () => {
            clearInterval(interval);
        };
    }, [hourConfig, entity]);

    return {
        validateHourDisabled,
        hourConfig
    }
}